var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgTransfixLogo = function SvgTransfixLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4816 31.6839H25.6357L13.2498 15.8419L25.6357 0H20.157L7.77107 15.8419L14.9086 24.9715H12.7119L5.57443 15.8419L17.9603 0H12.4816L0.0957031 15.8419L12.4816 31.6839Z",
    fill: "#0072B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6355 0H12.4814L24.8674 15.8419L12.4814 31.6839H17.9602L30.3461 15.8419L23.2086 6.71233H25.4053L32.5427 15.8419L20.1568 31.6839H25.6355L38.0215 15.8419L25.6355 0Z",
    fill: "black"
  })));
};
var Memo = /*#__PURE__*/memo(SvgTransfixLogo);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/logos/transfix-logo.6b26002addbb61b57752599001360dd8.svg";